<template>
  <div class="khattach" v-if="khattachVisible">
    <vxe-modal
      v-model="khattachVisible"
      :before-hide-method="closeDialog"
      width="700px"
      show-zoom
      resize
      transfer
      show-footer
    >
      <template #title>
        <span>权限分配</span>
      </template>
      <template #default>
        <div style="overflow-y: scroll; height: 260px">
          <vxe-table
            resizable
            show-overflow
            keep-source
            ref="xTable"
            row-id="id"
            :row-config="{ isHover: true, useKey: true }"
            :print-config="{}"
            :export-config="{}"
            :loading="loading"
            :tree-config="treeConfig"
            :checkbox-config="{ labelField: 'name', checkRowKeys: partRight }"
            :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
            :data="functionRight"
            :show-header="false"
            :stripe="false"
          >
            <vxe-column type="checkbox" tree-node></vxe-column>
          </vxe-table>
        </div>
      </template>
      <template #footer>
        <span class="dialog-footer">
          <el-row :gutter="20">
            <el-col :span="8" class="btnright">
              <el-button
                type="primary"
                size="medium"
                :disabled="saveOrdel"
                @click="saveEdit"
                >确 定</el-button
              >
              <el-button plain size="medium" @click="ToggleProps"
                >取 消</el-button
              >
            </el-col>
          </el-row>
        </span>
      </template>
    </vxe-modal>
  </div>
</template>
<script>
import { GetDataPermissionList } from "@api/Company/ApiPermission.js";
import { AddRolePermissions } from "@api/Company/ApiRolePermission.js";
import Enumerable from "linq";
export default {
  data() {
    return {
      loading: false,
      treeConfig: {
        transform: true,
        rowField: "id",
        parentField: "parentId",
      },
      saveOrdel: false,
      functionRight: [],
    };
  },
  components: {},
  props: ["partRight", "khattachVisible", "RoleId"],
  mounted() {
    this.loadPermissions();
  },
  created() {},
  methods: {
    loadPermissions() {
      let _this = this;
      let PageQuery = {
        pageindex: 1,
        pageSize: 1000,
        queryModel: {
          sortField: {
            OrderNo: "ASC",
          },
        }
      };
      this.loading = true;
      GetDataPermissionList(PageQuery).then(function ({ entities }) {
        _this.loading = false;
        _this.functionRight = entities;
      });
    },
    closeDialog() {
      //关闭dialog
      this.ToggleProps();
    },
    ToggleProps() {
      //取消
      this.$emit("update:khattachVisible", false);
    },
    saveEdit() {
      let _this = this;
      this.saveOrdel = true;
      let RoleId = this.RoleId;
      let permissions = this.$refs.xTable.getCheckboxRecords();
      let permissionIds = [];
      if (permissions.length > 0) {
        permissionIds = Enumerable.from(permissions)
          .where((x) => x.linkUrl != "")
          .select((x) => x.id)
          .toArray();
      }
      AddRolePermissions(RoleId, permissionIds).then((result) => {
        _this.$emit("update:khattachVisible", false);
        _this.saveOrdel = false;
        _this.$message.success("设置成功");
      });
    },
  },
  watch: {},
};
</script>
<style scoped>
.khattach >>> .el-dialog__footer {
  text-align: center;
}
.khattach >>> .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 8px;
}
.khattach >>> .el-form-item__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.khattach >>> .el-input-number .el-input__inner {
  -webkit-appearance: none;
  text-align: left;
}
.khattach >>> .el-input-number--small {
  line-height: 30px;
  width: 100%;
}
.khattach >>> .el-input-number {
  position: relative;
  display: inline-block;
  width: 100%;
}
.khattach /deep/ .dialog-footer .el-row {
  margin: 0 !important;
}
.khattach /deep/ .btnright {
  float: right;
  padding: 0 !important;
  text-align: right;
}
.khattach /deep/ .el-tree-node__label {
  margin-left: 10px;
}
</style>
